module.exports = __webpack_public_path__ + "img/gongjian.prt.99afc602.jpg";